import React, { useState, useEffect, useRef } from 'react';
import './App.css';

import Hero from './sections/Hero/Hero';
import Timeline from './sections/Timeline/Timeline';
import Participants from './sections/Participants/Participants';
import ParticipationRights from './sections/ParticipationRights/ParticipationRights';
import Mentor from './sections/Mentor/Mentor';
import Webinar from './sections/Webinar/Webinar';
import Livestream from './sections/Livestream/Livestream';
import CompanyTour from './sections/CompanyTour/CompanyTour';
import ContactQR from './sections/ContactQR/ContactQR';
import CompanyParticipants from './sections/CompanyParticipants/CompanyParticipants';
import Checkin from './sections/Checkin/Checkin';
import PremiumAccount from './sections/PremiumAccount/PremiumAccount';
import QnA from './sections/QnA/QnA';
import About from './sections/About/About';
import Footer from './sections/Footer/Footer';

const DESIGN_WIDTH = 1921;

function App() {
  const [scale, setScale] = useState(1);
  const [scaledHeight, setScaledHeight] = useState('auto');
  const innerRef = useRef(null);

  useEffect(() => {
    const inner = innerRef.current;
    if (!inner) return;

    function updateScale() {
      const vw = window.innerWidth;
      const newScale = vw / DESIGN_WIDTH;
      setScale(newScale);
      setScaledHeight(inner.scrollHeight * newScale);
    }

    // Use ResizeObserver to re-measure whenever inner content changes height
    // (covers initial paint, image loads, dynamic content, etc.)
    const ro = new ResizeObserver(() => {
      const vw = window.innerWidth;
      const s = vw / DESIGN_WIDTH;
      setScale(s);
      setScaledHeight(inner.scrollHeight * s);
    });
    ro.observe(inner);

    updateScale();
    window.addEventListener('resize', updateScale);
    return () => {
      ro.disconnect();
      window.removeEventListener('resize', updateScale);
    };
  }, []);

  return (
    <>
      {/* Outer wrapper: tells the browser how tall the scaled content actually is */}
      <div style={{ width: '100vw', height: scaledHeight, overflow: 'hidden' }}>
        {/* Inner: actual 1921px wide Figma canvas, scaled to fit viewport */}
        <div
          ref={innerRef}
          style={{
            width: DESIGN_WIDTH,
            transformOrigin: 'top left',
            transform: `scale(${scale})`,
          }}
        >
          <Hero />
          <Timeline />
          <Participants />
          <ParticipationRights />
          <Mentor />
          <Webinar />
          <Livestream />
          <CompanyTour />
          <ContactQR />
          <CompanyParticipants />
          <Checkin />
          <PremiumAccount />
          <QnA />
          <About />
        </div>
      </div>
      {/* Footer renders outside the scaled/clipped canvas at full viewport width */}
      <Footer />
    </>
  );
}

export default App;
